export const GROUPS_API_PATH = {
  LIST: "/v1/groups/",
  BOOKING: "/v1/groups/booking/",
  BOOKING_DETAIL: "/v1/groups/booking/{0}/",
  BOOKING_PASSENGERS: "/v1/groups/booking/{0}/",
  PAY_NOW: "/v1/groups/pay-now/",
  PAYMENT_OTP: "/v1/groups/payment/otp/",
  INVOICE: "/v1/groups/invoice/",
};

export const EDITABLE_PASSENGER_STATUSES = ["ON_HOLD", "CONFIRMED"];
